import { SignalingChannelBase } from '../webrtc/signaling-channel-base';
export class EmbeddedSignalingChannel extends SignalingChannelBase {
    constructor(eventListener, connectionFactory, connection, groupName, isInitiator, previewScope, supportsDataChannels, role, instanceId) {
        super(eventListener, connectionFactory, groupName, isInitiator, previewScope, supportsDataChannels, role, instanceId);
        this.connection = connection;
        this.type = 'embedded';
        this.isConnected = true;
        // Subscribe to messages coming from the embedded client
        connection.signalingMessage = (message) => {
            // Make sure that the message is for us in case it is a PeerMessage. We might get outdated messages if
            // an embedded window is being reloaded and loads faster than the host can set up a new embedded signaling channel.
            if (this.isConnected) {
                const peerMessage = message;
                if (!peerMessage.toClientId || (peerMessage.toClientId === this.clientId)) {
                    this.handleSignalingMessage(message);
                }
                // else {
                //     console.log(`${this.role}: received message intended for other (disposed?) client ${peerMessage.toClientId}`, message);
                // }
            }
        };
        eventListener.onChannelReady(this);
    }
    sendSignalingMessage(message) {
        if (!this.isConnected) {
            if (message.type === 5 /* SignalingMessageType.LeaveGroup */)
                return; // don't throw errors if leaving (probably closing the browser)
            throw `Signaling: unable to send signaling message. The client is not connected.`;
        }
        switch (message.type) {
            // The following message types are normally (when using remote signaling) handled by the signaling server.
            // Since there is no server in between with embedded signaling, we're handling them locally.
            case 2 /* SignalingMessageType.JoinGroupRequest */:
                const joinGroupRequestMessage = message;
                // const clientId = joinGroupRequestMessage.isHost ? `embedded-host` : `embedded-guest-${joinGroupRequestMessage.scope}`;
                const clientId = Math.random().toString(36).substring(2, 8);
                const response = this.createJoinGroupResponseMessage(joinGroupRequestMessage, clientId);
                this.handleJoinGroupResponseMessage(response); // handle the fake "server" response (also sets this.clientId).
                // Notify others (that is, a parent or child window, depending on our role) that we've joined.
                // This is important for the WebRTC handshake to get started.
                const joinedMessage = this.createJoinedGroupMessage(joinGroupRequestMessage, clientId);
                this.connection.sendSignalingMessage(joinedMessage);
                break;
            case 5 /* SignalingMessageType.LeaveGroup */:
                // Notify others (that is, a parent or child window, depending on our role) that we've left.
                const leaveGroupMessage = message;
                const leftGroupMessage = {
                    type: 6 /* SignalingMessageType.LeftGroup */,
                    clientId: this.clientId, // clientId is assigned during JoinGroupRequest above
                    groupName: leaveGroupMessage.groupName
                };
                this.connection.sendSignalingMessage(leftGroupMessage);
                break;
            default:
                this.connection.sendSignalingMessage(message);
                break;
        }
    }
    createJoinGroupResponseMessage(message, clientId) {
        const response = {
            type: 3 /* SignalingMessageType.JoinGroupResponse */,
            clientId: clientId,
            groupName: message.groupName,
            isHost: message.isHost,
            success: true
        };
        return response;
    }
    createJoinedGroupMessage(message, clientId) {
        const response = {
            type: 4 /* SignalingMessageType.JoinedGroup */,
            isHost: message.isHost,
            scope: message.scope,
            clientId: clientId,
            canUseWebRTC: message.canUseWebRTC
        };
        return response;
    }
}
//# sourceMappingURL=embedded-signaling-channel.js.map